import { useTranslation } from '@fluxora/i18n';
import { Alert } from '@fluxora/ui';

/**
 * AC2 — the estimate disclaimer. Always rendered on the estimate screen: the
 * figure is an ESTIMATE and must NEVER be presented as a guaranteed price. The
 * copy is counsel-facing compliance language rendered via `t()`, never hardcoded.
 */
export function EstimateDisclaimer(): JSX.Element {
  const { t } = useTranslation();
  return (
    <Alert variant="info" title={t('shop.estimate.disclaimer.title')} role="note">
      {t('shop.estimate.disclaimer.body')}
    </Alert>
  );
}
